import {combineReducers} from 'redux';
import {handleActions} from 'redux-actions';

import * as actionTypes from 'web-app/react/constants/action-types';

import {accountReducer} from './account/reducer';
import * as Actions from './actions';

const accessTokenReducer = handleActions(
    {
        [actionTypes.DID_RECEIVE_ACCESS_TOKEN]: (state, action) => {
            return action.payload;
        },
    },
    null,
);

const freePackageBehavior = handleActions(
    {
        [Actions.updateFreePackageBehavior.type]: (state, action) => {
            return action.payload;
        },
    },
    null,
);

export default combineReducers({
    account: accountReducer,
    accessToken: accessTokenReducer,
    freePackageBehavior,
});
